import { ChatSetAction, ChatSetActionResponse } from "../proto/ChatSetAction_pb";
import { GroupSetActionResponse } from "../proto/GroupSetAction_pb";
import store from "../store";
import { deleteRoomAction, setRoomAction } from "../store/rooms/actions";
import BaseHandler from "./BaseHandler";
import { getStorage } from "../libs/storage";
import { STORAGE_USER_ID } from "../constants/localstorage";
import { ClientAction, Room } from "../proto/Global_pb";
import { protoHandler } from "../libs/proto";
import { USER_INFO } from "../constants/methods";

export default class HandleRoomSetActionResponse extends BaseHandler<ChatSetActionResponse, GroupSetActionResponse> {
  handleRoomAction = async (roomSetActionResponse: ChatSetActionResponse.AsObject) => {
    try {
      if (!store.getState().users.users[roomSetActionResponse.userId]) {
        await protoHandler(USER_INFO, { userId: roomSetActionResponse.userId });
      }
      store.dispatch(
        setRoomAction({
          roomId: roomSetActionResponse.roomId,
          userId: [roomSetActionResponse.userId],
          action: roomSetActionResponse.action,
        })
      );
    } catch (e) {}
  };
  handle() {
    const roomSetActionResponse = this.response.toObject();
    const roomType = store.getState().rooms.rooms[roomSetActionResponse.roomId]?.type;
    switch (roomType) {
      case Room.Type.GROUP: {
        if (roomSetActionResponse.userId === getStorage(STORAGE_USER_ID)) return;
        if (roomSetActionResponse.action === ClientAction.CANCEL) {
          return store.dispatch(
            deleteRoomAction({
              roomId: roomSetActionResponse.roomId,
              userId: roomSetActionResponse.userId,
              action: roomSetActionResponse.action,
            })
          );
        }
        this.handleRoomAction(roomSetActionResponse).then();
        break;
      }
      case Room.Type.CHAT: {
        if (roomSetActionResponse.userId === getStorage(STORAGE_USER_ID)) return;
        store.dispatch(
          setRoomAction({
            roomId: roomSetActionResponse.roomId,
            userId: [roomSetActionResponse.userId],
            action: roomSetActionResponse.action,
          })
        );
        break;
      }
    }
    setTimeout(() => {
      if (roomSetActionResponse.roomId)
        store.dispatch(
          setRoomAction({
            roomId: roomSetActionResponse.roomId,
            userId: [],
            action: ClientAction.CANCEL,
          })
        );
    }, 10000);
  }
}
